import { defineStore } from 'pinia'
import { CreateUsuarioDto } from '@models'

export const useAuthStore = defineStore({
  id: 'authUser',
  state: () => ({
    isAuthenticated: false,
    user: {} as Partial<CreateUsuarioDto>,
    role: null as 'ADMIN' | 'USER' | null,
    aceiteTermoUso: false
  }),

  actions: {

    async isOrTryAuthenticate (force = false) {
      if (this.isAuthenticated && !force) { return true }
      const user = await this.getMe()
      if (user) { return true }
      return false
    },

    async getMe () {
      try {
        const user = await useApi<CreateUsuarioDto>('/auth/me', { method: 'GET' })
        if (user) {
          this.isAuthenticated = true
          this.user = user
          this.role = user?.role
          this.aceiteTermoUso = user.aceiteTermoDeUso.length > 0
          return user
        } else { // Pq o endpoint ou retorna o usuario, ou retorna o erro 400 abaixo unautenticate
          // qualquer coisa diferente disso, é um erro do servidor, como apontamento apra url errada, etc
          alert('Estamos com problema no servidor! Tente novamente mais tarde.')
        }
      } catch (e) {
        if (e.status === 400) { // unautenticate
          return false
        }
        if (e.status === 502) {
          alert('Estamos com problema no servidor! Tente novamente mais tarde.')
        }
        return false
      }
    },

    async loginUserPassword (cpf:string, password:string) {
      try {
        const login = await useApi<CreateUsuarioDto>('/auth/login-admin', { method: 'POST', body: { cpf, password } })
        if (login) {
          const user = await this.getMe()
          if (user) { return true }
        }
      } catch (e) {
        if (e.status === 502) {
          alert('Estamos com problema no servidor! Tente novamente mais tarde.')
        }
        return false
      }
      return false
    },

    async aceitarTermoDeUso () {
      try {
        const aceite = await useApi('/usuarios/aceite-termo-de-uso', { method: 'POST' })
        this.aceiteTermoUso = true
      } catch (e) {
        alert('Ocorreu algum erro. Tente mais tarde.')
        return false
      }
    },

    async logOutUrl () {
      if (this.isAuthenticated === false) { return false }
      try {
        const logoutUrl = await useApi('/auth/logout', { method: 'POST' })
        this.isAuthenticated = false
        this.user = {}
        this.role = null
        return logoutUrl
      } catch (e) {
        alert('Erro ao deslogar!') // TODO - melhorar?
        console.error(e)
        return false
      }
    }
  },

  getters: {
    isAdmin: state => state.role === 'ADMIN'
  }
})
